import React, { Component } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

import { withAuthentication } from './components/Session'
import { WhereToGo } from './components/Auth'
import PreviewBanner from './components/PreviewBanner'
import paperDashboardTheme from './theme/muiTheme'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/demo/demo.css'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import './assets/scss/paper-dashboard.scss?v=1.3.0'
import 'adaptivecards/dist/adaptivecards.css'
import LogRocket from 'logrocket'
LogRocket.init('f5hyli/falcon')

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={paperDashboardTheme}>
        <CssBaseline />
        <PreviewBanner />
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<WhereToGo />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    )
  }
}

export default withAuthentication(App)